import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "./SocialIcons";
import mapaBrasil from "@/assets/mapa-quadras-crop.png";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] as const } },
};
const stagger = { visible: { transition: { staggerChildren: 0.1 } } };

const steps = [
  {
    num: "01",
    title: "Fabricamos, não aplicamos.",
    text: "Nosso foco é em desenvolver e produzir o sistema de pintura completo na nossa fábrica.",
  },
  {
    num: "02",
    title: "Você define o frete",
    text: "A entrega é feita por transportadora ou empresa de frete contratada pelo cliente.",
  },
  {
    num: "03",
    title: "Ou orçamos com parceiros",
    text: "Se preferir, cotamos o transporte com nossas transportadoras parceiras.",
  },
];

const CoberturaNacional = () => (
  <section className="relative overflow-hidden bg-foreground py-24">
    {/* Grid decorativo */}
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        backgroundImage:
          "linear-gradient(hsl(0 0% 100% / .04) 1px, transparent 1px), linear-gradient(90deg, hsl(0 0% 100% / .04) 1px, transparent 1px)",
        backgroundSize: "54px 54px",
        maskImage: "radial-gradient(ellipse 70% 80% at 70% 50%, #000, transparent 75%)",
        WebkitMaskImage: "radial-gradient(ellipse 70% 80% at 70% 50%, #000, transparent 75%)",
      }}
    />

    <div className="container relative max-w-[1120px]">
      <div className="grid items-center gap-11 lg:grid-cols-2 lg:gap-14">

        {/* ─── Coluna de texto (esquerda no desktop) ─── */}
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
          <motion.span
            variants={fadeUp}
            className="inline-flex items-center gap-[9px] font-mono text-[0.72rem] uppercase tracking-[0.2em] text-accent"
          >
            <span className="h-px w-[22px] bg-accent" />
            Cobertura nacional
          </motion.span>

          <motion.h2
            variants={fadeUp}
            className="mt-[18px] text-[1.9rem] font-extrabold leading-[1.06] tracking-[-0.05em] text-background sm:text-[2.3rem] md:text-[2.7rem]"
          >
            O esporte joga sobre a Indusport em{" "}
            <span className="text-accent">todo o Brasil</span>.
          </motion.h2>

          <motion.p
            variants={fadeUp}
            className="mt-[18px] max-w-[46ch] text-[1.05rem] leading-[1.62] text-background/70"
          >
            Nossos produtos moldam a performance do esporte em quadras de norte a sul. Somos uma fábrica — nosso foco é produzir o material com a melhor tecnologia de superfície.
          </motion.p>

          <motion.div variants={fadeUp} className="mt-[30px] flex flex-col">
            {steps.map((step, i) => (
              <div
                key={step.num}
                className={`grid gap-4 py-4 border-t border-white/10${i === steps.length - 1 ? " border-b" : ""}`}
                style={{ gridTemplateColumns: "auto 1fr" }}
              >
                <span className="pt-0.5 font-mono text-[0.78rem] font-semibold text-accent">
                  {step.num}
                </span>
                <div>
                  <h4 className="text-[1rem] font-bold text-background">{step.title}</h4>
                  <p className="mt-1 text-[0.86rem] leading-[1.5] text-background/60">{step.text}</p>
                </div>
              </div>
            ))}
          </motion.div>

          <motion.div variants={fadeUp} className="mt-[30px] flex flex-wrap gap-[14px]">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[54px] items-center gap-[10px] rounded-lg bg-primary px-7 text-[0.95rem] font-semibold text-primary-foreground shadow-[0_10px_24px_-10px_rgba(0,95,85,0.6)] transition-all duration-200 hover:-translate-y-px hover:brightness-110"
            >
              Solicitar orçamento <ArrowRight className="h-[18px] w-[18px]" />
            </a>
            <Link
              to="/produtos"
              className="inline-flex min-h-[54px] items-center rounded-lg border-2 border-white/30 px-7 text-[0.95rem] font-semibold text-background transition-all duration-200 hover:border-white hover:bg-white/10"
            >
              Ver produtos
            </Link>
          </motion.div>
        </motion.div>

        {/* ─── Coluna do mapa (direita no desktop, topo no mobile) ─── */}
        <motion.div
          className="relative flex justify-center order-first lg:order-last"
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <div
            className="pointer-events-none absolute"
            style={{
              inset: "6%",
              background: "radial-gradient(circle at 50% 45%, hsl(172 100% 35% / 0.28), transparent 65%)",
              filter: "blur(40px)",
            }}
          />
          <img
            srcSet={mapaBrasil}
            sizes="(min-width:768px) 500px, 90vw"
            alt="Mapa do Brasil formado por fotos de quadras esportivas Indusport"
            loading="lazy"
            className="relative w-full max-w-[500px] [filter:drop-shadow(0_30px_50px_rgba(0,0,0,0.5))]"
          />
        </motion.div>
      </div>
    </div>
  </section>
);

export default CoberturaNacional;
